import * as Styled from './CustomFieldsResponses.styles';

import { useDebounce, downloadXLSFile, sendGAEvent } from 'utils/utils';
import { generatePath, useHistory, useParams } from 'react-router-dom';

import { CustomFieldsResponsesProps } from './types';
import { Icon } from 'features/common/components/Icon';
import { IdParamsType } from 'utils/types';
import { MainHeader } from 'features/common/components/MainHeader';
import { MainLayout } from 'layouts/MainLayout';
import { ROUTES } from 'features/routes';
import { ResponsesTable } from './components/ResponsesTable/ResponsesTable';
import { Search } from 'features/common/components/Search';
import { getData } from 'services/api';
import { useEventCustomFields } from './hooks/useEventCustomFields';
import { useSwitchTicketBridge } from './hooks/useSwitchTicketBridge';
import useGetEvent from 'features/common/hooks/useGetEvent';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

export const CustomFieldsResponses = ({ isAttendeesList = false }: CustomFieldsResponsesProps) => {
	const { t } = useTranslation();
	const { push } = useHistory();
	const { event } = useGetEvent();
	const { id } = useParams<IdParamsType>();
	const { setSearchText, responsesQueryObject, sortBy, order, handleSort } = useEventCustomFields(isAttendeesList);
	useSwitchTicketBridge();

	const searchDebounce = useDebounce(setSearchText);

	const isLottery = useMemo(() => {
		return event?.ticketTypes.some((ticketType) => ticketType.isLottery);
	}, [event]);

	const handleDownload = async () => {
		const response = await getData(`/events/${id}/custom-fields/responses/download`, {
			params: { all_attendees: isAttendeesList },
			responseType: 'blob',
			headers: { 'Content-Type': 'blob' },
		});

		downloadXLSFile(response, 'Responses');
		sendGAEvent({ category: 'Custom Fields', action: 'Custom Fields Responses download' });
	};

	return (
		<MainLayout>
			<MainHeader lessPadding gap="12px">
				<Icon
					cursor="pointer"
					iconName="arrowLeft"
					title="Return to Show Dashboard"
					onClick={() => push(generatePath(ROUTES.DASHBOARD_PATH, { id }))}
				/>
				<Styled.Title element="h1">{t('customFields-responses-title')}</Styled.Title>
			</MainHeader>

			<Styled.Container>
				<Styled.CustomFlexContainer>
					<Search
						width="300px"
						onChange={(e) => searchDebounce(e.target.value)}
						placeholder={t('search-email-or-name')}
					/>
					<Styled.Buttons>
						{isLottery && (
							<Styled.ActionButton onClick={() => push(ROUTES.SCANS.replace(':id', id))}>Scans</Styled.ActionButton>
						)}
						<Styled.ActionButton onClick={handleDownload}>{t('customFields-responses-download')}</Styled.ActionButton>
					</Styled.Buttons>
				</Styled.CustomFlexContainer>

				<ResponsesTable
					responsesQueryObject={responsesQueryObject}
					isAttendeesList={isAttendeesList}
					eventMode={event?.mode || 'normal'}
					sortBy={sortBy}
					order={order}
					onSort={handleSort}
				></ResponsesTable>
			</Styled.Container>
		</MainLayout>
	);
};
